import React from 'react';
import { ActivityIcon, FileTextIcon, GitBranchIcon, LayersIcon, StethoscopeIcon, TableIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { includedAssets } from '../../data/content';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  protocols: FileTextIcon,
  algorithms: GitBranchIcon,
  hormones: ActivityIcon,
  tables: TableIcon,
  special: LayersIcon,
  cases: StethoscopeIcon
};
export function SystemExtras() {
  return <section className="bg-paper-50 px-5 py-14 sm:px-8 sm:py-20" data-id="element-261" data-mp="1bq56vgeyzz3f">
      <div className="mx-auto max-w-5xl" data-id="element-262" data-mp="xq3xtdojxlcv">
        <SectionHeading tone="light" title="This Is More Than 6 Digital Books" subtitle="It’s your TRT clinical reference system. Inside, you’ll also receive:" data-id="element-263" data-mp="xt8bd1nwptg7" />

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-264" data-mp="3ijqvscbu1ypg">
          {includedAssets.map(asset => {
          const Icon = icons[asset.icon] ?? FileTextIcon;
          return <article key={asset.title} className="flex flex-col rounded-2xl border border-paper-200 bg-white p-5" data-id="element-265" data-mp="lgft9ri7tbno">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-50" data-id="element-266" data-mp="ug2nntcj1h78">
                  <Icon className="h-5 w-5 text-teal-600" data-id="element-267" data-mp="qc4kn7k2zm8w" />
                </span>
                <h3 className="mt-4 text-base font-extrabold leading-snug text-ink-900 sm:text-lg" data-id="element-268" data-mp="14cfd2f11h8w6">
                  {asset.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-600" data-id="element-269" data-mp="zcjhn46eqps8">{asset.body}</p>
              </article>;
        })}
        </div>

        <div className="mt-10 rounded-2xl border border-ink-900/10 bg-white p-6 sm:p-8" data-id="element-270" data-mp="1958kjanw6vby">
          <p className="text-center font-display text-sm font-bold uppercase tracking-[0.2em] text-teal-600" data-id="element-271" data-mp="1n36rhuzvvphf">
            The result?
          </p>
          <div className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-272" data-mp="1i2snco1ekzoo">
            <div className="rounded-xl bg-paper-100 p-4" data-id="element-273" data-mp="fsin3lh2mvdz">
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-ink-500/70" data-id="element-274" data-mp="kqk4m1yummnc">
                Instead of asking
              </p>
              <p className="mt-2 text-base font-semibold leading-snug text-ink-600 line-through decoration-alert-500/60 sm:text-lg" data-id="element-275" data-mp="orcf0yjgixl7">
                “Where do I find the answer to this?”
              </p>
            </div>
            <div className="rounded-xl bg-ink-900 p-4" data-id="element-276" data-mp="yk1ltg42bna7">
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-teal-300" data-id="element-277" data-mp="13g8qz6omwur3">
                You’ll ask
              </p>
              <p className="mt-2 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-278" data-mp="18gwli2c2ntq2">
                “Which pathway applies to this patient?”
              </p>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-279" data-mp="3a9ugo4tbmye6">
          <CtaButton label="Get the Master System of TRT™" subLabel="6 Volumes · 300+ Protocols · 30+ Cases · USD 27" data-id="element-280" data-mp="3ea4mnhh45ot1" />
        </div>
      </div>
    </section>;
}